module.exports = maybeEmail => {
    return /.+@.+\..+/i.test(maybeEmail);
};



// WEBPACK FOOTER //
// ./src/utils/is-email.js